/**
 * Constants
 *
 * Developed By : Travancore Analytics (2025)
 * Author: Akhil Soman
 * Created on: 02/01/2022
 * Project: Vitromed
 * Revision History:
 * SNo.   | Date        | Author        | Task                | Comments |
 * 1      28/02/2025    Akhil Soman       Creating new File
 * 2      13/03/2025    Nidhin Sudhakaran       Added S3 video upload API
 */

const Constant = {
  VBaseUrl: process.env.REACT_APP_BASE_URL,
  signIn: "/api/auth/signin",
  signUp: "/api/auth/admin/signup",
  question: "/api/questions",
  topic: "/api/topics",
  assessment: "/api/assessment",
  userdetails: "/api/usersdetails",
  userlist: "/api/userslist",
  updateuser: "/api/userupdate",
  s3VideoUploadUrl: "/api/s3videouploadurl",
  assessmentanswers: "/api/assessmentanswers",
  addAsset: "/api/addassets",
  getAssets: "/api/addassets?IsHighlighted=true",
  getVideoUrl: "/api/s3videouploadurl",
  sendemail: "/api/sendemails",
  assessmentparticipants: "/api/assessmentparticipants",
  assetcategory: "/api/assetcategory",
};

export default Constant;
